// extracted by css-extract-rspack-plugin
export default {"cls1":"NameList-cls1_02n","cls2":"NameList-cls2_8yS NameList-cls1_02n"};